import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { GetFaqList, getFaqList, getError } from '@frontend/public-store';
import { AuthService, LoginSuccess } from '@frontend/auth-store';
import { LocalstorageService } from '@frontend/app-config';

@Component({
  selector: 'frontend-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit, OnDestroy {
  faqList: any[] = [];
  isLoading = true;
  hasError = false;
  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private localStorageService: LocalstorageService,
  ) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.handleAutoLogin();
    this.store.dispatch(GetFaqList());

    this.store.select(getFaqList)
      .pipe(takeUntil(this.destroy$))
      .subscribe((list: any) => {
        if (list !== null) {
          this.isLoading = false;
          this.faqList = list.filter((item: any) => item.is_active);
        }
      });

    this.store.select(getError)
      .pipe(takeUntil(this.destroy$))
      .subscribe((error: any) => {
        if (error) {
          this.isLoading = false;
          this.hasError = true;
        }
      });
  }

  private handleAutoLogin(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) return;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true,
    });

    this.authService.autoLogin(token).subscribe({
      next: (resp: any) => {
        if (resp?.success && resp?.data) {
          const user = { ...resp.data, id: resp.data._id };
          this.localStorageService.updateUserKey('store', user);
          this.store.dispatch(LoginSuccess({ loginUser: user, message: resp.message }));
        }
      },
      error: () => {},
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
